import React from 'react';
import Modal from "react-bootstrap/Modal";
import { confirmable } from 'react-confirm';


class Confirmation extends React.Component {

    render() {
        const {
            okLabbel = 'Yes',
            cancelLabel = 'No',
            title,
            confirmation,
            show,
            proceed,
            dismiss,
            cancel,
            enableEscape = true,
            showNoOption = true
        } = this.props;
        return (

            <div className="static-modal">
                <Modal show={show} onHide={dismiss} backdrop={enableEscape ? true : 'static'} keyboard={enableEscape}>
                    <Modal.Header>
                        <Modal.Title>{title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {confirmation}
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-lightblue" onClick={proceed}>{okLabbel}</button>
                        {showNoOption ? <button onClick={cancel} className="btn btn-lightblue">{cancelLabel}</button> : null}

                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}
export default confirmable(Confirmation);


// WEBPACK FOOTER //
// ./src/components/common/modals/confirmation.js